import { Component, Input, OnInit, AfterViewInit } from "@angular/core";
import { JqueryExtensionsService } from "../services/jquery.service";
import { StringExtensions } from "../utilities/string.extensions";
//import { PlatformLocation } from '@angular/common'

@Component({
	selector: "modal",
	template: `
		<div class="modal fade {{id}}" tabindex="-1" role="dialog" [attr.aria-labelledby]="id" [attr.data-backdrop]="backdrop" [attr.data-keyboard]="keyboardDismiss">
			<div class="modal-dialog {{classes}}">
				<div class="modal-content">
					<div class="modal-header"> <ng-content select="[modal-header]"> </ng-content></div>
					<div class="modal-body"> <ng-content select="[modal-body]"> </ng-content></div>
					<div class="modal-footer"> <ng-content select="[modal-footer]"> </ng-content></div>
				</div>
			</div>
		</div>
	`
})
export class ModalComponent implements OnInit, AfterViewInit {
	@Input() id: string;
    @Input() classes: string = "";
    @Input() backdrop: string = "true";
    @Input() keyboardDismiss: string = "true";

	private element: JQuery;

	constructor(private jqueryService: JqueryExtensionsService) { }

	ngOnInit() {
        if (!this.id) { this.id = "modal-" + StringExtensions.generateUUID(); }
	}

	ngAfterViewInit() {
    this.element = this.jqueryService.selectElement("." + this.id);
    this.element.on('hidden.bs.modal', function () {
      $('.modal-backdrop').remove();
    });
	}

	show(): void {
		this.element.modal("show");
		//this.location.onPopState(() => {
		//	$('.modal-backdrop').remove();
  //      });
	}

	hide(): void {
		this.element.modal("hide");
	}
}
